import { render, staticRenderFns } from "./ClientInfo.vue?vue&type=template&id=66949e9e&"
import script from "./ClientInfo.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ClientInfo.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports